module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAALVBMVEUAAABckTtckTtckTvu7u7dLkTdLkTdLkTdLkRckTtckTvdLkTdLkRckTvdLkQr1T3fAAAAD3RSTlMAYL////+/YAAgz88g7+8ykxn6AAAAaElEQVR4AWOgPxgFQsYw4IIEQmEgvaODoWOWMX5FoXs6GDovE1IUd4Khy5iQotAdDMKEFYUzKBNWFMZgTFhR6KBVNKpoVNGoolFFo4qIKuyJqjaIqoCIqsqIqxQ7OoipXgkCqioaVQQA6T+4O1FrCqUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f1ee-1f1f9.png
// module id = 599
// module chunks = 0